export type PublicationTimerResetScope = 'all' | 'user';

export const getPublicationTimerResetResult = (
  updated: number,
  scope: PublicationTimerResetScope
) => {
  if (updated === 0) {
    return {
      title: 'No listings extended',
      text:
        scope === 'user'
          ? 'No published listings to extend for this user.'
          : 'No published listings to extend.',
    };
  }

  const listing = updated === 1 ? 'listing' : 'listings';
  const verb = updated === 1 ? 'was' : 'were';
  const target = scope === 'user' ? ' for this user' : '';

  return {
    title: 'Publication period extended',
    text: `${updated} published ${listing}${target} ${verb} extended by 90 days.`,
  };
};
